import React, {useCallback, useState} from 'react';
import {Button, Col, Container, Table} from 'react-bootstrap';
import {httpClient} from "../../service";
import {ActionResult, HttpMethod} from "../../model";
import {useAsync} from "react-async";
import LoadingHtml from "../../shared/Loading";
import ErrorPage from "../../shared/ErrorPage";
import {Link} from 'react-router-dom';
import {getSessionVerify, TtaSecModel} from '../verifications/VerifyConfigModel';
import T3Detail from './t3Detail';

export const Verification2t3 = () => { // 추가
    const url = 'test/tta3';
    const model=getSessionVerify();
    const options = {promiseFn: httpClient, method: HttpMethod.GET, url,body: model};
    const [loading, setLoading] = useState<boolean>(false);
    const onDeleteProcess =  useCallback(async(e: any) => {
        e.preventDefault();
        const ans = window.confirm("검증데이타를 초기화 하시겠습니까? 초기화하면 현재 검증데이타가 삭제됩니다.");
        if (ans == false) return false;
        console.log(`click button id=${e.target}`);
        setLoading(true);
        const url = `test/tta`;
        const options = {
            method: HttpMethod.DELETE,
            url,
            body: {...model, ttaNum: 3}
        }
        const act = await httpClient(options);
        setLoading(false);
        if (act.result) {
            window.location.reload();
        } else {
            alert(act.errorMsg);
        }
    },[]);
    const {data: act, error, isLoading} = useAsync<ActionResult>(options);
    const refresh=useCallback(async()=>{
        window.location.reload();
    },[]);
    if (isLoading) return <LoadingHtml/>;
    if (error) return <ErrorPage/>;
    if (!act) return null;
    if (!act.result) return <ErrorPage action={act}/>;
    const data: TtaSecModel[] = act.data;

    return (
        <>
            <div className="bloc l-bloc">
                <Container className="bloc-sm verify-bloc">
                    <div className="row mb-1">
                        <Col className="text-left col-sm-3">
                            <Link to="/verification2" className="btn btn-sm btn-primary">Home</Link>
                            &nbsp;
                            <Link to="/verification2/config" className="btn btn-sm btn-info">환경설정</Link>
                            &nbsp;
                            <Button className="btn-danger" size="sm" onClick={onDeleteProcess}
                                    disabled={loading}>초기화</Button>
                            &nbsp;
                            <Button className="btn-secondary" size="sm" onClick={refresh}>새로고침</Button>
                        </Col>
                        <Col className={'text-center col-sm-6'}>
                            검증3
                        </Col>
                        <Col className="text-right col-sm-3">
                            [회원번호: <span className="text-primary">{model.custNo}</span>]
                        </Col>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <Table striped bordered hover size="sm" variant="dark" className={'tta'}>
                                <colgroup>
                                    <col style={{width: '40px'}}/>
                                    <col style={{width: '120px'}}/>
                                    <col style={{width: '120px'}}/>
                                    <col style={{width: '120px'}}/>
                                    <col style={{width: '120px'}}/>

                                    <col style={{width: '60px'}}/>
                                    <col style={{width: '60px'}}/>
                                    <col style={{width: '60px'}}/>
                                    <col style={{width: '120px'}}/>

                                    <col style={{width: '100px'}}/>
                                    <col/>
                                    <col style={{width: '80px'}}/>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th className="align-center">#</th>
                                    <th className="align-center">Recency<div className={'td-label'}>구매 최근성/일</div></th>
                                    <th className="align-center">Frequency<div className={'td-label'}>구매빈도</div></th>
                                    <th className="align-center">arpu<div className={'td-label'}>객단가</div></th>
                                    <th className="align-center">검증</th>
                                    <th className="align-center">R</th>
                                    <th className="align-center">F</th>
                                    <th className="align-center">M</th>
                                    <th className="align-center">RFM Score(1~9)</th>
                                    <th className="align-center">쿠폰</th>
                                    <th className="align-center">지급쿠폰</th>
                                    <th className="align-center">검증</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    data && data.map((item, i) => {
                                        return <T3Detail item={item} key={i} index={i}/>
                                    })
                                }
                                </tbody>
                            </Table>
                        </div>

                    </div>
                </Container>
            </div>
        </>
    )
};

